import React, { useState } from "react";
import { Text } from "../Base";
import { View } from "../View";
import { palette } from "../../theme/palette";
import { Grid, IconButton, SvgIcon } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Close, InfoOutlined } from "@mui/icons-material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { collectionFieldToIcon } from "../../consts/collections";
import { LegendTextIcon } from "./LegendTextIcon";
import {
  COLLECTION_MAP_LEGEND_ICON,
  COLLECTION_MAP_LEGEND_CLOSE,
} from "../../consts/sentryIds";

const useStyles = makeStyles({
  container: {
    color: palette.typography.white.solid,
    width: "213px",
    position: "absolute",
    left: "30px",
    bottom: "19px",
    zIndex: 3,
  },
  infoButton: {
    height: "22px",
    width: "22px",
    color: palette.white,
    position: "absolute",
    bottom: "-10px",
    left: "calc(50% - 50px/2 - 98.09px)",
  },
  gridContainer: {
    position: "absolute",
    height: "249px",
    bottom: "35px",
    left: "-1px",
    background: "black",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-evenly",
  },
  shadow: {
    position: "absolute",
    height: "100px",
    width: "218px",
    bottom: "28px",
    left: "-2px",
    borderRadius: "8px 8px 8px 0px",
    background: `linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 50%, rgba(0,0,0,.15) 50%, rgba(0,0,0,.15) 100%)`,
  },
  stump: {
    width: "15px",
    height: "31px",
    position: "absolute",
    bottom: "15px",
    left: "-5px",
    zIndex: 3,
  },
  gridTitle: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "10px",
  },
  gridItem: {
    marginLeft: "10px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  legendTitle: {
    fontSize: "18px",
  },
  legendText: {
    fontSize: "11px",
    margin: "0px 7px",
  },
  closeButton: {
    height: "16px",
    width: "16px",
    color: palette.grey,
  },
});

export const MapLegend = () => {
  const styles = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const legendItems = [
    {
      ...collectionFieldToIcon.lowerLevelAdjustments,
      text: "Lower Zoom Level Adjustments",
    },
    {
      ...collectionFieldToIcon.sameDayCutOff,
      text: "Same Day-Cut Off",
    },
    {
      ...collectionFieldToIcon.earliestReadyTime,
      text: "Earliest Ready Time",
    },
    {
      ...collectionFieldToIcon.latestReadyTime,
      text: "Latest Ready Time",
    },
    {
      saturn: true,
      text: "Saturn Auto",
    },
  ];

  const renderLegendItems = (legendItems) => {
    return legendItems.map((legendItem) => {
      const { saturn, icon, colour, text } = legendItem;
      if (saturn) {
        return (
          <Grid item={true} className={styles.gridItem}>
            <PhoneIphoneIcon />
            <Text className={styles.legendText}>{text}</Text>
          </Grid>
        );
      }
      return (
        <Grid item={true} className={styles.gridItem}>
          <LegendTextIcon text={icon} backgroundColor={colour} />
          <Text className={styles.legendText}>{text}</Text>
        </Grid>
      );
    });
  };

  return (
    <View className={styles.container}>
      {isOpen && (
        <>
          <View className={styles.shadow} />
          <Grid
            className={styles.gridContainer}
            container
            spacing={1}
            direction="column"
          >
            <Grid item={true} className={styles.gridTitle}>
              <Text className={styles.legendTitle}>Legend</Text>
              <IconButton
                className={styles.closeButton}
                onClick={() => {
                  setIsOpen(false);
                }}
                sentryId={COLLECTION_MAP_LEGEND_CLOSE}
                size="large"
              >
                <Close />
              </IconButton>
            </Grid>
            {renderLegendItems(legendItems)}
          </Grid>
          <SvgIcon className={styles.stump}>
            <svg
              width="18"
              height="33"
              viewBox="0 0 23 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.00012 14.8419C1.00014 11.8156 0.612609 -5.2525 1.00007 2.49945C1.34879 9.4764 14.8114 9.97008 17.526 9.99906C17.8402 9.98298 18.0077 9.99976 18 9.99976C17.9964 9.99976 17.8275 10.0023 17.526 9.99906C16.3679 10.0583 13.2172 10.5638 9.5 14C4.77418 18.3686 2.19188 31.7893 2.19188 31.7893C1.99326 32.1928 1.47684 32.9998 1.00014 32.9998L1.00007 31.184L1.00012 14.8419Z"
                fill="black"
                transform="scale(1.5) translate(-0.5)"
              />
            </svg>
          </SvgIcon>
        </>
      )}
      <IconButton
        className={styles.infoButton}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        sentryId={COLLECTION_MAP_LEGEND_ICON}
        size="large"
      >
        <InfoOutlined />
      </IconButton>
    </View>
  );
};
